import styled from 'styled-components'

export const ButtonsContainer = styled.div`
  position: relative;
  margin-bottom: 0.5rem;
  padding-left: 0.5rem;
  padding-right: 1.5rem;
  width: 100%;
  display: grid;
  grid-template-columns: auto minmax(150px, 200px) 170px;
  direction: rtl;
`

const DatesButton = styled.button`
  padding: 2px 0.5rem;
  background: transparent;
  border: 1px solid ${props => props.theme.colors.color122d52};
  border-radius: 200px;
  cursor: pointer;
  transition: all 0.2s ease-in-out;

  display: flex;
  align-items: center;
  gap: 0.25rem;

  color: ${props => props.theme.colors.color122d52};
  font-family: 'Inter';
  font-size: 12px;
  font-style: normal;
  font-weight: 400;
  line-height: 12px;

  svg {
    width: 6px;
    fill: ${props => props.theme.colors.color122d52};
  }

  &:hover:not(:disabled) {
    background: ${props => props.theme.colors.color122d52};
    color: ${({ theme }) => theme.zds.colors.neutral1000};
    svg {
      fill: ${({ theme }) => theme.zds.colors.neutral1000};
    }
  }

  &:disabled {
    color: ${props => props.theme.colors.color5a6a7e};
    background: ${props => props.theme.colors.colore4e8ef};
    border: 1px solid ${props => props.theme.colors.colore4e8ef};
    cursor: not-allowed;

    svg {
      fill: ${props => props.theme.colors.color5a6a7e};
    }
  }
`

export const NewestDatesButton = styled(DatesButton)``
export const PreviousDatesButton = styled(DatesButton)``
